import { render, staticRenderFns } from "./PageTopbar.vue?vue&type=template&id=16e27822&scoped=true"
import script from "./PageTopbar.vue?vue&type=script&lang=ts"
export * from "./PageTopbar.vue?vue&type=script&lang=ts"
import style0 from "./PageTopbar.vue?vue&type=style&index=0&id=16e27822&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e27822",
  null
  
)

/* custom blocks */
import block0 from "./PageTopbar.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports